import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const Header = () => {
  const { currentUser, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header style={styles.header}>
      <div style={styles.container}>
        <Link to="/" style={styles.logo}>RealEstatePro</Link>
        
        <nav style={styles.nav}>
          <Link 
            to="/" 
            style={{
              ...styles.navLink,
              ...(location.pathname === '/' && styles.activeNavLink)
            }}
          >
            Početna
          </Link>
          <Link 
            to="/nekretnine" 
            style={{
              ...styles.navLink,
              ...(location.pathname === '/nekretnine' && styles.activeNavLink)
            }}
          >
            Nekretnine
          </Link>
          
          {isAdmin() && (
            <Link 
              to="/admin" 
              style={{
                ...styles.navLink,
                ...(location.pathname === '/admin' && styles.activeNavLink)
              }}
            >
              Admin
            </Link>
          )}
        </nav>
        
        <div style={styles.authSection}>
          {currentUser ? (
            <div style={styles.userMenu}>
              <span style={styles.userName}>{currentUser.name}</span>
              <button onClick={handleLogout} style={styles.logoutButton}>Odjava</button>
            </div>
          ) : (
            <div style={styles.authLinks}>
              <Link 
                to="/prijava" 
                style={{
                  ...styles.authLink,
                  ...(location.pathname === '/prijava' ? styles.activePrijava : styles.inactivePrijava)
                }}
              >
                Prijava
              </Link>
              <Link 
                to="/registracija" 
                style={{
                  ...styles.authLink,
                  ...(location.pathname === '/registracija' ? styles.activeRegistracija : styles.inactiveRegistracija)
                }}
              >
                Registracija
              </Link>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

const styles = {
  header: {
    backgroundColor: '#2c3e50',
    color: 'white',
    padding: '1rem 0',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px'
  },
  logo: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: 'white',
    textDecoration: 'none'
  },
  nav: {
    display: 'flex',
    gap: '1.5rem'
  },
  navLink: {
    color: 'white',
    textDecoration: 'none',
    padding: '0.5rem',
    borderRadius: '4px',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.1)'
    }
  },
 
  activeNavLink: {
    backgroundColor: 'rgba(255,255,255,0.2)',
    boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
    fontWeight: 'bold',
    transform: 'translateY(-2px)'
  },
  authSection: {
    display: 'flex',
    alignItems: 'center'
  },
  authLinks: {
    display: 'flex',
    gap: '1rem'
  },
  authLink: {
    color: 'white',
    textDecoration: 'none',
    padding: '8px 16px',
    borderRadius: '30px',
    fontWeight: '600',
    transition: 'all 0.3s ease',
    border: '2px solid transparent',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
  },
  
  activePrijava: {
    backgroundColor: '#27ae60',
    '&:hover': {
      backgroundColor: '#219653',
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 12px rgba(0,0,0,0.15)'
    }
  },
 
  inactivePrijava: {
    backgroundColor: 'transparent',
    border: '2px solid #27ae60',
    '&:hover': {
      backgroundColor: 'rgba(39, 174, 96, 0.1)'
    }
  },
  
  activeRegistracija: {
    backgroundColor: '#27ae60',
    '&:hover': {
      backgroundColor: '#219653',
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 12px rgba(0,0,0,0.15)'
    }
  },
 
  inactiveRegistracija: {
    backgroundColor: 'transparent',
    border: '2px solid #27ae60',
    '&:hover': {
      backgroundColor: 'rgba(39, 174, 96, 0.1)'
    }
  },
  userMenu: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem'
  },
  userName: {
    fontSize: '0.9rem'
  },
  logoutButton: {
    padding: '0.5rem 1rem',
    backgroundColor: '#e74c3c',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor: '#c0392b'
    }
  }
};

export default Header;